module.exports = __webpack_public_path__ + "img/bj-dt-1.2883b478.jpg";